'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _trimEnd = require('lodash/trimEnd');

var _trimEnd2 = _interopRequireDefault(_trimEnd);

var _isNil = require('lodash/isNil');

var _isNil2 = _interopRequireDefault(_isNil);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = require('../styles');

var _styles2 = _interopRequireDefault(_styles);

var _tokens = require('../styles/tokens');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styles = function styles(theme) {
    return {
        // Styles applied to root
        root: {},

        // Styles applied when paragraph and shouldRenderExtraLines is true
        skeletonBody: {
            display: 'flex',
            flexDirection: 'column'
        },

        // Styles applied to each row rendered when paragraph is set
        skeletonRow: {
            backgroundColor: theme.palette.grey[250],
            height: _tokens.spacing40,
            borderRadius: _tokens.borderRadiusSmall
        },

        // Styles applied to each row rendered when paragraph is set and the amount of lines are > 1
        skeletonRowMultiple: {
            marginBottom: _tokens.spacing50,
            '&:last-child': {
                marginBottom: 0
            }
        },

        // Styles applied when paragraph
        paragraph: {},

        // Styles applied when circle
        circle: {
            backgroundColor: theme.palette.grey[250],
            borderRadius: _tokens.borderRadiusCircle
        },

        // Styles applied when rectangle
        rectangle: {
            borderRadius: _tokens.borderRadiusSmall,
            backgroundColor: theme.palette.grey[250]
        },

        // Create Pulse animation
        '@keyframes pulsate': {
            '0%': {
                opacity: 1
            },
            '50%': {
                opacity: 0.4
            },
            '100%': {
                opacity: 1
            }
        },
        // Pulse animation
        pulse: {
            animation: '$pulsate 1.5s ease-in-out 0.5s infinite'
        }
    };
};

function convertRemToPixels(rem) {
    return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

function calculateNumberOfRows(container, rowAttributes) {
    // get the container height
    var availableHeight = container.scrollHeight;
    var numRows = void 0;

    if (availableHeight > 0) {
        var lineHeight = convertRemToPixels(Number((0, _trimEnd2.default)(_tokens.spacing50, 'rem')));
        var margin = convertRemToPixels(Number((0, _trimEnd2.default)(_tokens.spacing50, 'rem')));
        var rowHeight = lineHeight + margin;
        numRows = Math.floor(availableHeight / rowHeight) + 1;
    }
    return numRows;
}

/**
 * A low fidelity representation of the user interface (UI) as content is loading on the page to give users a visual cue of what content is being loaded.
 * @done true
 * @updated false
 * @versionAdded v5.4.0
 * @examples
 * DefaultSkeleton
 * OnComponents
 */
var Skeleton = _react2.default.forwardRef(function (props, ref) {
    var paragraph = props.paragraph,
        circle = props.circle,
        rectangle = props.rectangle,
        animation = props.animation,
        Component = props.component,
        classes = props.classes,
        rest = _objectWithoutProperties(props, ['paragraph', 'circle', 'rectangle', 'animation', 'component', 'classes']);

    var skeletonRef = _react2.default.useRef();

    var _useState = (0, _react.useState)([]),
        _useState2 = _slicedToArray(_useState, 2),
        rows = _useState2[0],
        setRows = _useState2[1];

    (0, _react.useEffect)(function () {
        if (paragraph) {
            var numberOfRows = void 0;
            // Calculate numberOfRows
            if (!(0, _isNil2.default)(paragraph.numberOfLines)) {
                if (typeof paragraph.numberOfLines === 'number') {
                    numberOfRows = paragraph.numberOfLines;
                } else if (paragraph.numberOfLines === 'fit') {
                    var parentElement = skeletonRef.current.parentElement;
                    numberOfRows = calculateNumberOfRows(parentElement, paragraph);
                }
            } else {
                numberOfRows = 1;
            }
            setRows(new Array(numberOfRows).fill(100));
        }
    }, [paragraph, animation, ref]);

    var getComputedSizingValue = function getComputedSizingValue(value) {
        // if the value has the word sku in it, return the value multipled by 8.
        if (typeof value === 'string' && value.includes('sku')) {
            var sku = value.replace('sku', '');
            return sku * 8;
        }
        return value;
    };

    var renderParagraph = function renderParagraph() {
        var shouldRenderExtraLines = typeof paragraph.numberOfLines === 'number' && paragraph.numberOfLines !== 1;

        return _react2.default.createElement(
            Component,
            Object.assign({
                ref: skeletonRef,
                className: (0, _classnames2.default)(classes.root, classes.paragraph, _defineProperty({}, classes.skeletonBody, shouldRenderExtraLines))
            }, rest),
            rows.map(function (width, index) {
                var _cn2;

                return _react2.default.createElement('div', {
                    key: index,
                    className: (0, _classnames2.default)(classes.skeletonRow, (_cn2 = {}, _defineProperty(_cn2, classes[animation], animation !== false), _defineProperty(_cn2, classes.skeletonRowMultiple, rows.length > 1), _cn2)),
                    style: { width: width + '%' }
                });
            })
        );
    };

    var renderCircle = function renderCircle() {
        return _react2.default.createElement(Component, Object.assign({
            className: (0, _classnames2.default)(classes.root, classes.circle, _defineProperty({}, classes[animation], animation !== false)),
            style: { width: getComputedSizingValue(circle.width), height: getComputedSizingValue(circle.height) }
        }, rest));
    };

    var renderRectangle = function renderRectangle() {
        return _react2.default.createElement(Component, Object.assign({
            className: (0, _classnames2.default)(classes.root, classes.rectangle, _defineProperty({}, classes[animation], animation !== false)),
            style: { width: getComputedSizingValue(rectangle.width), height: getComputedSizingValue(rectangle.height) }
        }, rest));
    };

    if (paragraph) {
        return renderParagraph();
    } else if (circle) {
        return renderCircle();
    } else if (rectangle) {
        return renderRectangle();
    }
});

Skeleton.muiName = 'Skeleton';
Skeleton.displayName = 'Skeleton';

Skeleton.propTypes = {

    /**
     * Override or extend the styles applied to the component.
     */
    classes: _propTypes2.default.object,

    /**
     * @ignore
     */
    className: _propTypes2.default.string,

    /**
     * @ignore
     */
    edsContext: _propTypes2.default.object,

    /**
     * @ignore
     */
    children: _propTypes2.default.node,

    /**
     * @ignore
     * The animation.
     */
    animation: _propTypes2.default.oneOf([false, 'pulse']),
    /**
     * The component used for the root node. Either a string to use a HTML element or a component.
     */
    component: _propTypes2.default.elementType,
    /**
     * Render the component as a paragraph.
     *
     *
     * This prop also accepts an object in the following form:
     *
     * `numberOfLines`: @number: The number of lines the `Skeleton` component will render.
     * || @string: 'fit' When set to fit, this will automatically render the correct number of lines if the parent
     *   container has a height set.
     */
    paragraph: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
        numberOfLines: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
    })]),
    /**
     * Render the component as a circle.
     *
     * This prop also accepts an object in the following form:
     *
     * `width`: Valid CSS value, or an `sku` multiplier. (i.e. '24px', '24', '1.5rem', '3sku')
     *
     * `height`: Valid CSS value, or an `sku` multiplier. (i.e. '24px', '24', '1.5rem', '3sku')
     * *We recommend that the width and height should be equal values.
     */
    circle: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
        width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
        height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
    })]),
    /**
     * Render the component as a rectangle.
     *
     * This prop also accepts an object in the following form:
     *
     * `width`: Valid CSS value, or an `sku` multiplier. (i.e. '24px', '24', '1.5rem', '3sku')
     *
     * `height`: Valid CSS value, or an `sku` multiplier. (i.e. '24px', '24', '1.5rem', '3sku')
     */
    rectangle: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
        width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
        height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
    })])
};

Skeleton.defaultProps = {
    animation: 'pulse',
    component: 'div'
};

exports.default = (0, _styles2.default)(styles)(Skeleton);